import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import classNames from 'classnames'
import { connect } from 'react-redux'
import store from 'base/store'
import Event from 'base/event'
import Hub from 'base/hub'
import ReferralBanner from 'base/components/layout/banners/referral_banner'
import OutOfMarketInternationalBanner from 'base/components/layout/banners/out_of_market_international_banner'
import { canRenderReferralBanner, canRenderOutOfMarketInternationalBanner } from 'base/lib/banners'
import SessionMessagingBanner from 'base/components/layout/banners/session_messaging_banner'
import CurrentCountryDisplay from 'base/react/components/current_country_display'
import CountrySelectModal from 'desktop/components/modals/country_select_modal'
import { getLocalization } from 'base/lib/localization'
import BuilderComponent from 'base/components/pages/builder/component'

export const BANNER_HEIGHT = 40

function getOverrideBanner({ internationalShippingCountries }) {
  const platform = 'desktop'

  if (canRenderReferralBanner()) {
    const latestReferral =
      store.getState().session.visitor && store.getState().session.visitor.latestReferral
        ? store.getState().session.visitor.latestReferral.user.display_name
        : 'A friend'

    return <ReferralBanner platform={platform} nameOfReferrer={latestReferral} />
  }

  if (canRenderOutOfMarketInternationalBanner(internationalShippingCountries)) {
    return <OutOfMarketInternationalBanner platform={platform} />
  }

  return <BuilderComponent model="banner" />

  return null
}

export function BannerRenderer({
  isMobile,
  platform,
  internationalShippingCountries,
  isDefaultLocalization,
  isOnSearchPage,
  builderBannerEnabled,
  showingFlyoutCart,
}) {
  const [banner, setBanner] = React.useState(null)
  const [isShowingCountrySelectModal, setIsShowingCountrySelectModal] = React.useState(false)

  useEffect(() => {
    if (!internationalShippingCountries) {
      return
    }
    async function fetchBanner() {
      const overrideBanner = getOverrideBanner({
        internationalShippingCountries,
        builderBannerEnabled,
      })

      if (overrideBanner) {
        setBanner(overrideBanner)
      }
    }

    fetchBanner()
  }, [internationalShippingCountries, builderBannerEnabled])

  // dont render banner until actual localization is fetched from ip address
  if (isDefaultLocalization) return null

  return (
    <div
      className={classNames('banner-renderer', {
        'banner-renderer--mobile-search': isMobile && isOnSearchPage,
      })}
    >
      {internationalShippingCountries && banner}
      {isShowingCountrySelectModal && (
        <CountrySelectModal onRequestClose={() => setIsShowingCountrySelectModal(false)} />
      )}

      <div className="banner-renderer__session-messaging-banner">
        <SessionMessagingBanner platform={platform} />
      </div>

      {platform === 'desktop' && !showingFlyoutCart && (
        <div className="banner__country-select">
          <CurrentCountryDisplay
            onClickCountryDisplay={() => {
              setIsShowingCountrySelectModal(true)
              Hub.pub(Event.Header.COUNTRY_TRAY_OPEN, {})
            }}
            flagClassName="current-country-display__flag--banner"
            compact
          />
        </div>
      )}
    </div>
  )
}

BannerRenderer.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  platform: PropTypes.string,
  showSessionMessage: PropTypes.bool,
  isDefaultLocalization: PropTypes.bool,
  internationalShippingCountries: PropTypes.object,
  showingFlyoutCart: PropTypes.bool,
}

BannerRenderer.defaultProps = {
  platform: 'desktop',
  showSessionMessage: false,
  showingFlyoutCart: false,
}

function mapStateToProps(state) {
  return {
    isMobile: state.appConfig.isMobile,
    internationalShippingCountries: state.shippingConstants.international_shipping_countries,
    isDefaultLocalization: getLocalization().is_default,
    showingFlyoutCart: state?.flyoutCart?.showing,
  }
}

export default connect(mapStateToProps)(BannerRenderer)
